import React, { useState } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Image,
  SafeAreaView,
  ScrollView,
} from 'react-native';
import { ms, s, vs } from '../../utils/responsive';
import { NavigationProp } from '@react-navigation/native';
import OrnamentBackground from '../../components/OrnamentBackground';
import VerificationCodeInput from '../../components/VerificationCodeInput';

const CodeVerificationScreen = ({
  navigation,
}: {
  navigation: NavigationProp<any>;
}) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);

  const handleVerify = () => {
    // TEMPORARY: Accept any 6-digit code for demo mode
    if (code.length === 6) {
      setError(false);
      // Reset navigation stack and go to Dashboard
      navigation.reset({
        index: 0,
        routes: [{ name: 'Dashboard' }],
      });
    } else {
      setError(true);
    }
  };

  const handleCloseError = () => {
    setError(false);
    setCode(''); // Reset the code input
  };

  return (
    <SafeAreaView style={styles.container}>
      <OrnamentBackground />

      <View style={styles.topSection}>
        <Image source={require('../../assets/logo.png')} style={styles.logo} />
        <Text style={styles.welcomeText}>2-Step Verification</Text>
        <Text style={styles.description}>
          One step closer. We have sent you an one time code to your phone, please check messages and enter the code below.
        </Text>
      </View>

      <View style={styles.mainContainer}>
        {error && (
          <View style={styles.errorContainer}>
            <View style={styles.errorContent}>
              <Text style={styles.errorTitle}>Verification Code Invalid</Text>
              <Text style={styles.errorMessage}>
                Seems like you've entered the wrong code, please re-check and input it again.
              </Text>
              <TouchableOpacity style={styles.closeButton} onPress={handleCloseError}>
                <Text style={styles.closeButtonText}>×</Text>
              </TouchableOpacity>
            </View>
          </View>
        )}

        <View style={styles.inputContainer}>
          <ScrollView style={styles.scrollView}>
            <View style={styles.inputGroup}>
              <Text style={styles.label}>Verification Code</Text>
              <VerificationCodeInput value={code} onChangeText={setCode} />
            </View>

            <View style={styles.buttonContainer}>
              <TouchableOpacity
                style={[styles.verifyButton, { opacity: code.length === 6 ? 1 : 0.6 }]}
                onPress={handleVerify}
                disabled={code.length !== 6}
              >
                <Text style={styles.verifyButtonText}>Verify</Text>
              </TouchableOpacity>
            </View>

            <View style={styles.bottomPadding} />
          </ScrollView>
        </View>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#29BFC0',
  },
  topSection: {
    alignItems: 'center',
    paddingVertical: ms(20),
    flex: 0.88,
  },
  logo: {
    width: s(120),
    height: s(120),
    marginBottom: ms(16),
  },
  welcomeText: {
    fontSize: ms(28, 0.3),
    fontWeight: 'bold',
    color: '#FFFFFF',
    marginBottom: ms(8),
  },
  description: {
    fontSize: ms(16, 0.3),
    color: '#FFFFFF',
    textAlign: 'center',
    marginBottom: ms(20),
    paddingHorizontal: ms(40),
  },
  mainContainer: {
    flex: 0.93,
    position: 'relative',
  },
  errorContainer: {
    backgroundColor: '#E85C5C',
    paddingVertical: ms(25),
    paddingHorizontal: ms(20),
    borderTopLeftRadius: ms(20),
    borderTopRightRadius: ms(20),
    marginBottom: ms(-20),
    position: 'relative',
    zIndex: 1,
  },
  errorContent: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  errorTitle: {
    fontSize: ms(16, 0.3),
    color: '#FFFFFF',
    fontWeight: 'bold',
    marginBottom: ms(4),
  },
  errorMessage: {
    fontSize: ms(14, 0.3),
    color: '#FFFFFF',
    textAlign: 'center',
    opacity: 0.8,
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    padding: ms(5),
  },
  closeButtonText: {
    color: '#FFFFFF',
    fontSize: ms(24, 0.3),
    fontWeight: 'bold',
  },
  inputContainer: {
    flex: 1,
    backgroundColor: '#F3F6F8',
    borderTopLeftRadius: ms(20),
    borderTopRightRadius: ms(20),
    paddingTop: ms(30),
    position: 'relative',
    zIndex: 2,
  },
  scrollView: {
    paddingHorizontal: ms(16),
  },
  inputGroup: {
    marginBottom: ms(16),
    alignItems: 'center',
  },
  label: {
    fontSize: ms(22, 0.3),
    fontWeight: '600',
    color: '#6B7280',
    marginBottom: ms(40),
    textAlign: 'center',
  },
  buttonContainer: {
    paddingVertical: ms(20),
    paddingHorizontal: ms(16),
  },
  verifyButton: {
    backgroundColor: '#29BFC0',
    padding: ms(15),
    borderRadius: ms(25),
    alignItems: 'center',
  },
  verifyButtonText: {
    color: '#FFFFFF',
    fontSize: ms(18, 0.3),
    fontWeight: '600',
  },
  bottomPadding: {
    height: s(30),
  },
});

export default CodeVerificationScreen;